<template>
  <modal
    width="90%"
    speed="fast"
    noOutClose
    maskNoClick
    noFooter
    title="考试结果"
    :show="show"
    class="score-modal"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close">
    <div class="wrap" slot="content">
      <div class="mb-bg">
        <h3 :class="{ 'weisheng-h3': $route.path.split('/')[1].indexOf(weishengRoute) >= 0 }">恭喜你完成了考试</h3>
        <p v-if="info.has_subjective" class="objective">成绩暂时未公布</p>
        <p v-else-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0" class="bg-score">{{info.score}}<span>分</span></p>
        <p v-else class="bg-score"></p>
        <div class="time-cost" v-if="info.has_subjective">
          <span class="time-title">答题用时:</span><span class="time">{{info.time_cost | timeFactory}}</span>
        </div>
        <div v-else class="mb-info">
          <p><span>{{info.time_cost | timeFactory}}</span>答题用时</p>
          <p v-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0"><span>{{ pass ? '通过' : '未通过' }}</span>通过状态</p>
        </div>
        <div class="mb-btn-wrap">
          <a class="btn" @click="showPaper">
            {{$route.path.split('/')[1].indexOf(weishengRoute) >= 0 ? '确定' : '查看答卷'}}</a>
          <a class="btn"
             v-if="$route.path.split('/')[1].indexOf('nctsimutest') >= 0
             || repeat_test === 1
             || $route.path.split('/')[1].indexOf(eduteacherRoute) >= 0
             || $route.path.split('/')[1].indexOf(nocbcmRoute) >= 0"
             @click="reset"
             >
            重新考试</a>
        </div>
      </div>
      <div class="mb-loading-mask" v-show="showSaveLoading">
        <div class="loading-wrap">
          <looping-rhombuses-spinner
            :animation-duration="2500"
            :rhombus-size="30"
            :color="loadingColor"
            class="loading-icon"
          />
          <p>数据加载中...</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import { get, post } from '@/utils/ajax'
import { isCppTest, getTouristsVal } from '@/utils'
import { mapState } from 'vuex'
export default {
  components: {
    Modal,
    LoopingRhombusesSpinner
  },
  props: {
    show: Boolean,
    useParentExit: Boolean
  },
  data () {
    return {
      pass: '',
      timer: null,
      showSaveLoading: false,
      info: {
        time_cost: 0
      },
      repeat_test: 0,
      weishengInfo: {}
    }
  },
  filters: {
    timeFactory (timestamp) {
      timestamp = timestamp / 1000
      // let d = parseInt(timestamp / (24 * 60 * 60))
      // let h = parseInt((timestamp / (60 * 60)) % 24)
      let m = parseInt((timestamp / 60) % 60)
      let s = parseInt((timestamp) % 60)
      // d = d < 10 ? 0 + '' + d : d
      // h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return `${m}分${s}秒`
    }
  },
  computed: {
    ...mapState(['weishengRoute', 'eduteacherRoute', 'nocbcmRoute']),
    loadingColor() {
      return String(this.$store.state.theme.themeColor || '').replace(/;+\s*$/, '') || '#3D81FF'
    },
    examineeInfo () {
      return this.$store.state.examineeInfo
    }
  },
  mounted () {
    // this.showSaveLoading = true
    setTimeout(async () => {
      await this.check()
      await this.getResult()
    }, 500)
  },
  methods: {
    async getResult () {
      const res = await get(`/home/exams/${localStorage.examId}/examinees/${localStorage.user_id}/score_result`)
      this.info = res
      this.pass = res.score >= res.pass_score
      if (!res.score_complete) {
        this.timer = setTimeout(() => {
          this.getResult()
        }, 1000)
      } else {
        // 由于前端的不稳定性，如关掉页面不可调用这个接口，所以功能还需后端做
        await this.funcAPI()
        this.showSaveLoading = false
      }
    },
    async check () {
      const { repeat_test } = await get(`/home/exams/check/${localStorage.examId}`)
      this.repeat_test = repeat_test
    },
    async funcAPI () {
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        await this.weishengToken()
      } else if (this.$route.path.split('/')[1].indexOf(this.eduteacherRoute) >= 0) {
        await this.eduteacherAPI()
      }
    },
    async weishengToken () {
      // 传入API名以及请求参数对象
      const res = await post('/home/outsize/weisheng/users', { uniqId: localStorage.UniqId })
      // this.jsp('getUser.php', { UniqId: localStorage.UniqId || this.$route.query.uniq_id }).then(async (res) => {
      this.weishengInfo = res.data.user
      await post(`/home/outsize/weisheng/score`, {
        exam_id: localStorage.examId,
        score: this.info.score,
        token: this.weishengInfo.Token || '',
        uniqId: localStorage.UniqId || this.$route.query.uniq_id,
        user_id: localStorage.user_id
      })
      // }).catch((err) => {
      //   console.log(err)
      // })
    },
    async eduteacherAPI () {
      const info = JSON.parse(localStorage.eduTeacher)
      const infoItem = info['exam' + localStorage.examId]
      const body = {
        studentLearnRecordAddDTO: {
          unitId: infoItem.unitId,
          lessonId: infoItem.lessonId,
          resourceId: infoItem.resourceId,
          userId: localStorage.user_id,
          type: infoItem.type
        },
        studentTestRecordAddDTO: {
          examId: localStorage.examId,
          score: this.info.score,
          userId: localStorage.user_id
        }
      }
      await post('/home/outsize/eduzone/score', body)
    },
    async reset () {
      await post(`/home/edu/examinees/exams/reset`, { exam_id: localStorage.examId, examinee_id: this.examineeInfo.examinee_id })
      localStorage.removeItem('currentQuestionId') // 去掉上一次答题进度的缓存
      await this.startTest()
      location.reload()
    },
    async startTest() { // 重置开始考试的状态
      await post(`/home/edu/examinees/start/${localStorage.examId}/${this.examineeInfo.examinee_id}`)
    },
    // 查看试卷
    async showPaper () {
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        const redirection = await get(`/home/exams/${localStorage.examId}/regions`)
        if (redirection.over_link === 1) {
          await this.$store.dispatch('logout')
          localStorage.clear()
          this.$router.replace({ name: 'login' })
        } else {
          this.$router.replace({ name: 'list' })
        }
      } else {
        if (isCppTest()) {
          this.$router.push({ name: 'showPaper', params: { noBackTip: true } })
        } else {
          window.open(`${location.origin}/${location.href.split('/')[3]}/showPaper`, '_blank')
        }
      }
    },
    async close () {
      this.$emit('update:show', false)
      if (this.useParentExit) {
        this.$emit('exit')
        return
      }
      if (getTouristsVal()) {
        return this.$router.replace({ name: 'list', params: { noBackTip: true } })
      }
      const redirection = await get(`/home/exams/${localStorage.examId}/regions`)
      if (redirection.over_link === 1) {
        await this.$store.dispatch('logout')
        localStorage.clear()
        this.$router.replace({ name: 'login' })
      } else {
        this.$router.replace({ name: 'list' })
      }
    }
  }
  // destroyed () {
  //   clearTimeout(this.timer)
  //   this.timer = null
  // }
}
</script>

<style lang="scss" scoped>
.wrap {
  border-radius: 0.3rem;
  overflow: hidden;
}

.mb-bg {
  padding: 0.65rem 0.85rem 1.1rem;
  background: #fff;

  h3 {
    margin: 0.35rem 0 0.65rem;
    color: #222;
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
  }

  .weisheng-h3 {
    margin-bottom: 1.6rem;
  }

  .bg-score {
    height: auto;
    margin: 0.4rem 0;
    color: var(--mobile-theme);
    font-size: 2.5rem;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
  }

  .time-cost {
    margin: 1.2rem 0;
    color: #666;
    font-size: 0.8rem;
    text-align: center;
  }

  .time-title {
    color: #666;
  }

  .time {
    color: #333;
    font-size: 0.9rem;
    font-weight: 500;
  }

  span {
    margin-left: 0.25rem;
    font-size: 0.82rem;
    font-weight: 400;
  }

  .objective {
    margin: 0.5rem 0 1.25rem;
    color: #666;
    font-size: 0.85rem;
    text-align: center;
  }
}

.mb-info {
  display: flex;
  margin: 1.2rem 0;
  padding: 0.8rem 0;
  background: #f3fbf7;
  border-radius: 0.25rem;

  p {
    flex: 1;
    margin: 0;
    color: #777;
    font-size: 0.75rem;
    text-align: center;

    span {
      display: block;
      margin: 0 0 0.3rem;
      color: #333;
      font-size: 0.9rem;
      font-weight: 500;
    }

    & + p {
      border-left: 1px solid #dfebe5;
    }
  }
}

.mb-btn-wrap {
  display: flex;
  justify-content: center;
  gap: 0.55rem;

  .btn {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    min-height: 2.45rem;
    margin: 0;
    padding: 0 0.5rem;
    color: var(--mobile-theme);
    font-size: 0.82rem;
    text-align: center;
    border: 1px solid var(--mobile-theme);
    border-radius: 0.25rem;
    cursor: pointer;

    &:last-child {
      background: #fff;
    }

    &:first-child {
      color: #fff;
      background: var(--mobile-theme);
    }
  }
}

.mb-loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-wrap {
    display: flex;
    flex-direction: column;
    width: 6rem;
    height: 6rem;
    align-items: center;
    justify-content: center;

    p {
      margin-top: 0.6rem;
      color: #fff;
      font-size: 0.75rem;
    }
  }
}

/deep/ .dialog {
  max-width: 21rem;
  border-radius: 0.35rem;

  .modal-head {
    padding: 0.7rem 1rem;
    color: #333;
    font-size: 0.9rem;
    text-align: center;
  }

  .close-icon {
    top: 0.8rem;
    right: 0.9rem;
  }

  .content {
    padding: 0;
  }
}

@media only screen and (min-width: 48rem) and (max-width: 80rem) {
  /deep/ .dialog {
    max-width: 17.5rem;

    .modal-head {
      font-size: 0.58rem;
    }
  }

  .mb-bg {
    padding: 0.55rem 1rem 1rem;

    h3 {
      font-size: 0.65rem;
    }

    .bg-score {
      font-size: 2.2rem;
    }
  }

  .mb-btn-wrap .btn {
    min-height: 1.6rem;
    font-size: 0.52rem;
  }
}
</style>
